import React from "react";

export default function DataLakeHouse() {
  return (
    <section className="relative bg-[#1a1a22] text-white py-20">
      {/* Title */}
      <div className="text-center mb-16">
        <h2 className="!text-3xl md:t!ext-[45px] !font-bold">
          The First Centralized Data Lake House for Gaming
        </h2>
        <p className="text-[#9d9dbb] mt-2 md:!text-base">
          Turning Lost Data Into Liquid Value
        </p>
      </div>

      {/* Layout Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center max-w-6xl mx-auto relative">
        
        {/* Left Side */}
        <div className="space-y-6 z-10">
          {[
            { title: "Game Telemetry", desc: "2.5 TB/day per title", icon: "/static/data-lake/game-icon.svg" },
            { title: "Player Behavior", desc: "50M+ events/hour", icon: "/static/data-lake/player-icon.svg" },
            { title: "Match analytics", desc: "Real-time processing", icon: "/static/data-lake/analytics-icon.svg" },
            { title: "In-Game Events", desc: "Sub-ms latency", icon: "/static/data-lake/event-icon.svg" },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-[#292936] p-4 rounded-xl shadow hover:shadow-lg transition"
            >
              <div className="flex flex-col gap-3">
                <img className="w-5" src={item.icon} alt={item.icon} />
                <div>
                  <p className="!font-bold !text-base">{item.title}</p>
                  <p className="text-[#9d9dbb] !text-sm">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Center Logo */}
        <div className="relative flex justify-center">
        <img src="/static/data-lake/arrow-left.svg" alt="" />
          <img src="/static/brand/poger_logo.svg" className="animate-spin-slow w-44" alt="" />
          <img src="/static/data-lake/arrow-right.svg" alt="" />
        </div>

        {/* Right Side */}
        <div className="space-y-6 z-0">
  {[
    { value: "$185", title: "Per Player Value", desc: "Unlocked through intelligent data monetization" },
    { value: "47x", title: "ROI for Studios", desc: "Average return on data infrastructure investment" },
    { value: "/static/data-lake/ai-icon.svg", title: "AI Applications", desc: "Powering next-gen gaming experiences" },
  ].map((item, i) => {
    const isImage = typeof item.value === "string" && item.value.match(/\.(jpeg|jpg|gif|png|svg)$/);

    return (
      <div
        key={i}
        className="bg-[#1f2937] p-4 rounded-xl shadow hover:shadow-lg transition"
      >
        {isImage ? (
          <img
            src={item.value}
            alt={item.title}
            className="w-12 h-12 object-contain mb-2"
          />
        ) : (
          <p className="!text-[45px] !font-bold text-teal-400">{item.value}</p>
        )}

        <p className="!font-bold !text-base">{item.title}</p>
        <p className="text-[#9d9dbb] !text-sm">{item.desc}</p>
      </div>
    );
  })}
</div>

      </div>
    </section>

  );
}
